import {
  CustomLabel,
  FlexContainer,
  Input,
} from "@mindmemobile/mm-shared-global";
import React, { FC } from "react";
import {
  ProductVariantEditableAdvancedModel,
  ProductVariantEditableModel,
} from "../../../../../shared/models";
import {
  DescriptionCell,
  LabelCell,
  MainOuterCard,
  ProductDetailWrapper,
} from "../../../../../shared/styles";

type IProps = {
  editableVariant?: ProductVariantEditableModel | null;
  onUpdate: (variant: ProductVariantEditableModel) => void;
  isTrackInventory: boolean;
};

const VariantAdvancedSectionEditable: FC<IProps> = ({
  editableVariant,
  onUpdate,
  isTrackInventory,
}) => {
  if (!editableVariant || !editableVariant.advanced) return null;

  function onChange(
    key: keyof ProductVariantEditableAdvancedModel,
    value: string | boolean
  ) {
    if (!editableVariant?.price) return;

    const clone = new ProductVariantEditableAdvancedModel({
      ...editableVariant.advanced,
    });
    switch (key) {
      case "tax":
        clone.tax = value as boolean;
        break;
      case "surcharge":
        clone.surcharge = value as boolean;
        break;
      case "discount":
        clone.discount = value as boolean;
        break;
      case "review":
        clone.review = value as boolean;
        break;
      case "return":
        clone.return = value as boolean;
        break;
      case "isPromote":
        clone.isPromote = value as boolean;
        break;
      case "isSellOnOutOfStock":
        clone.isSellOnOutOfStock = value as boolean;
        break;
      case "isLimitPurchaseQuantity":
        clone.isLimitPurchaseQuantity = value as boolean;
        break;
      case "sku":
        clone.sku = value as string;
        break;
      case "barCode":
        clone.barCode = value as string;
        break;
      case "onHandQuantity":
        clone.onHandQuantity = value as string;
        break;
      case "quantityLimit":
        clone.quantityLimit = value as string;
        break;
      case "returnDays":
        clone.returnDays = value as string;
        break;
    }
    onUpdate(
      new ProductVariantEditableModel({
        ...editableVariant,
        advanced: new ProductVariantEditableAdvancedModel(clone),
      })
    );
  }
  function inputRow(
    label: string,
    value: string,
    key: keyof ProductVariantEditableAdvancedModel,
    className?: string
  ) {
    return (
      <div>
        <FlexContainer
          className={`label-description-row ${className}`}
          alignItems="center"
        >
          <LabelCell>
            <CustomLabel>{label}</CustomLabel>
          </LabelCell>
          <DescriptionCell>
            <Input
              type="text"
              error={editableVariant?.advanced.hasError(key)}
              value={value}
              onChange={(e) => onChange(key, e.target.value)}
            />
          </DescriptionCell>
        </FlexContainer>
      </div>
    );
  }

  function checkBox(
    label: string,
    value: boolean,
    key: keyof ProductVariantEditableAdvancedModel
  ) {
    return (
      <div>
        <FlexContainer>
          <Input
            type="checkbox"
            value={value}
            onChange={(e) => onChange(key, e.target.checked)}
            label={label}
          />
        </FlexContainer>
      </div>
    );
  }

  function inventorySection() {
    if (!editableVariant) return null;
    return (
      <div className="full-width">
        <FlexContainer fxLayout="column" spacing={20}>
          <CustomLabel fontWeight="600">Inventory</CustomLabel>
          {inputRow(
            "On Hand",
            editableVariant.advanced.onHandQuantity,
            "onHandQuantity",
            "return-days-chkbox"
          )}
          {checkBox(
            "Promote when inventory is low",
            editableVariant.advanced.isPromote,
            "isPromote"
          )}
          {checkBox(
            "Continue selling when out of stock",
            editableVariant.advanced.isSellOnOutOfStock,
            "isSellOnOutOfStock"
          )}
          <div>
            <FlexContainer spacing={10} alignItems="center">
              {checkBox(
                "Limit to",
                editableVariant.advanced.isLimitPurchaseQuantity,
                "isLimitPurchaseQuantity"
              )}
              {editableVariant.advanced.isLimitPurchaseQuantity &&
                inputRow(
                  "Quantity",
                  editableVariant.advanced.quantityLimit,
                  "quantityLimit",
                  "return-days-chkbox"
                )}
            </FlexContainer>
          </div>
        </FlexContainer>
      </div>
    );
  }
  return (
    <ProductDetailWrapper>
      <MainOuterCard>
        <CustomLabel
          fontSize="20px"
          fontWeight="600"
          margin="0px 0px 20px"
          color="#2C3E50"
        >
          Advanced
        </CustomLabel>
        <FlexContainer>
          <div className="full-width">
            <FlexContainer fxLayout="column" spacing={20}>
              <CustomLabel fontWeight="600">Allow</CustomLabel>
              {checkBox("Tax", editableVariant.advanced.tax, "tax")}
              {checkBox(
                "Surcharge",
                editableVariant.advanced.surcharge,
                "surcharge"
              )}
              {checkBox(
                "Discount",
                editableVariant.advanced.discount,
                "discount"
              )}
              {checkBox("Review", editableVariant.advanced.review, "review")}
              <div>
                <FlexContainer
                  spacing={10}
                  fxLayout="reverse"
                  alignItems="center"
                >
                  {" "}
                  {checkBox(
                    "Return",
                    editableVariant.advanced.return,
                    "return"
                  )}
                  {editableVariant.advanced.return &&
                    inputRow(
                      "days",
                      editableVariant.advanced.returnDays,
                      "returnDays",
                      "return-days-chkbox"
                    )}
                </FlexContainer>
              </div>
            </FlexContainer>
          </div>
          {isTrackInventory && inventorySection()}
        </FlexContainer>
        <FlexContainer
          padding="30px 0px 0px"
          className="tracking-shipping-block"
        >
          <div className="full-width">
            <FlexContainer fxLayout="column">
              <CustomLabel fontWeight="600" margin="0px 0px 20px">
                Tracking
              </CustomLabel>
              {inputRow("SKU", editableVariant.advanced.sku, "sku")}
              {inputRow(
                "Bar Code",
                editableVariant.advanced.barCode,
                "barCode"
              )}
            </FlexContainer>
          </div>
          {/* <div className="full-width">
                        <FlexContainer fxLayout="column">
                            <CustomLabel fontWeight="600" margin="0px 0px 20px">
                                Shipping
                            </CustomLabel>
                            {inputRow('SKU', editableVariant.advanced.sku, 'sku')}
                            {inputRow('Bar Code', editableVariant.advanced.barCode, 'barCode')}
                        </FlexContainer>
                    </div> */}
        </FlexContainer>
      </MainOuterCard>
    </ProductDetailWrapper>
  );
};
export default VariantAdvancedSectionEditable;
